export const GIVING_LECTURE = 'GIVING_LECTURE';
export const ATTENDANCE = 'ATTENDANCE';
export const WORKING_WITH_FAMILY = 'WORKING_WITH_FAMILY';
export const COOPERATION_IN_SYSTEM_ASSISTANCE = 'COOPERATION_IN_SYSTEM_ASSISTANCE';
export const OPEN_PARTY = 'OPEN_PARTY';
